import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'acehr43',
  Description:
    'Here\'s all the online content included with your <strong>English Literature Poetry Guide</strong>.',
  Credits:
    '<i>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',};